module.exports = __webpack_public_path__ + "img/6d3c5b1.png";